// Metadatos de estados de casos: paletas e íconos (clases estáticas para que Tailwind no las purgue).
import {
  FileText, Search, Eye, Lock, ShieldAlert, Shield, CheckCircle, XCircle,
  AlertTriangle, Clock, Flag, Star, Pause, Play, Archive, Ban, Gavel,
  UserCheck, Bell, Activity, Zap, Briefcase, Hourglass, ThumbsUp,
} from 'lucide-react';

// Paleta disponible para estados personalizados
export const COLOR_OPTIONS = [
  'slate', 'gray', 'red', 'orange', 'amber', 'yellow', 'lime', 'green',
  'emerald', 'teal', 'cyan', 'sky', 'blue', 'indigo', 'violet', 'purple',
  'fuchsia', 'pink', 'rose',
];

// Clases completas (NO construir dinámicamente: Tailwind purga las dinámicas)
export const COLOR_CLASSES = {
  slate: { badge: 'bg-slate-100 text-slate-800', kbg: 'bg-slate-50', kborder: 'border-slate-500', dot: 'bg-slate-500' },
  gray: { badge: 'bg-gray-100 text-gray-800', kbg: 'bg-gray-50', kborder: 'border-gray-500', dot: 'bg-gray-500' },
  red: { badge: 'bg-red-100 text-red-800', kbg: 'bg-red-50', kborder: 'border-red-500', dot: 'bg-red-500' },
  orange: { badge: 'bg-orange-100 text-orange-800', kbg: 'bg-orange-50', kborder: 'border-orange-500', dot: 'bg-orange-500' },
  amber: { badge: 'bg-amber-100 text-amber-800', kbg: 'bg-amber-50', kborder: 'border-amber-500', dot: 'bg-amber-500' },
  yellow: { badge: 'bg-yellow-100 text-yellow-800', kbg: 'bg-yellow-50', kborder: 'border-yellow-500', dot: 'bg-yellow-500' },
  lime: { badge: 'bg-lime-100 text-lime-800', kbg: 'bg-lime-50', kborder: 'border-lime-500', dot: 'bg-lime-500' },
  green: { badge: 'bg-green-100 text-green-800', kbg: 'bg-green-50', kborder: 'border-green-500', dot: 'bg-green-500' },
  emerald: { badge: 'bg-emerald-100 text-emerald-800', kbg: 'bg-emerald-50', kborder: 'border-emerald-500', dot: 'bg-emerald-500' },
  teal: { badge: 'bg-teal-100 text-teal-800', kbg: 'bg-teal-50', kborder: 'border-teal-500', dot: 'bg-teal-500' },
  cyan: { badge: 'bg-cyan-100 text-cyan-800', kbg: 'bg-cyan-50', kborder: 'border-cyan-500', dot: 'bg-cyan-500' },
  sky: { badge: 'bg-sky-100 text-sky-800', kbg: 'bg-sky-50', kborder: 'border-sky-500', dot: 'bg-sky-500' },
  blue: { badge: 'bg-blue-100 text-blue-800', kbg: 'bg-blue-50', kborder: 'border-blue-500', dot: 'bg-blue-500' },
  indigo: { badge: 'bg-indigo-100 text-indigo-800', kbg: 'bg-indigo-50', kborder: 'border-indigo-500', dot: 'bg-indigo-500' },
  violet: { badge: 'bg-violet-100 text-violet-800', kbg: 'bg-violet-50', kborder: 'border-violet-500', dot: 'bg-violet-500' },
  purple: { badge: 'bg-purple-100 text-purple-800', kbg: 'bg-purple-50', kborder: 'border-purple-500', dot: 'bg-purple-500' },
  fuchsia: { badge: 'bg-fuchsia-100 text-fuchsia-800', kbg: 'bg-fuchsia-50', kborder: 'border-fuchsia-500', dot: 'bg-fuchsia-500' },
  pink: { badge: 'bg-pink-100 text-pink-800', kbg: 'bg-pink-50', kborder: 'border-pink-500', dot: 'bg-pink-500' },
  rose: { badge: 'bg-rose-100 text-rose-800', kbg: 'bg-rose-50', kborder: 'border-rose-500', dot: 'bg-rose-500' },
};

export const ICON_MAP = {
  FileText, Search, Eye, Lock, ShieldAlert, Shield, CheckCircle, XCircle,
  AlertTriangle, Clock, Flag, Star, Pause, Play, Archive, Ban, Gavel,
  UserCheck, Bell, Activity, Zap, Briefcase, Hourglass, ThumbsUp,
};
export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const badgeClass = (color) => (COLOR_CLASSES[color] || COLOR_CLASSES.slate).badge;
export const kanbanClasses = (color) => COLOR_CLASSES[color] || COLOR_CLASSES.slate;
export const iconComp = (name) => ICON_MAP[name] || Flag;

// Convierte un estado personalizado de la API al formato {value,label,color,icon} usado en las vistas
export const mapCustomToEstado = (cs) => ({
  value: cs.key,
  label: cs.label,
  color: badgeClass(cs.color),
  colorName: cs.color,
  icon: iconComp(cs.icon),
  iconName: cs.icon,
  system: false,
});
